import React, { Component } from 'react';
import {connect} from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  ButtonDropdown,
  DropdownToggle as DropdownToggleBs,
  DropdownMenu,
  DropdownItem as DropdownItemBs
} from 'reactstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Tbl, TblHead, TblBody, Th } from '../../components/Tbl';
import Paginations from '../../components/Paginations';
import PaginationSummaries from '../../components/Paginations/PaginationSummaries';
import { getListVoucher } from '../../actions/voucherAction';
import { generateNumber } from '../../utils';
import { DEFAULT_SORT_BY, DEFAULT_PER_PAGE } from '../../constants/settings';
import DateToHuman from '../../components/DateToHuman';
import { TextRupiah } from '../../components/Text';
import CheckReadOnly from '../../components/CheckReadOnly';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import FilterPanel from './Filters';
import { CardHeaderWithToolbars, Title } from '../../components/Card/CardHeaderWithToolbars';
import Toolbars from './Filters/Toolbars'
import privateView from '../../components/hocs/privateView';
import { SimpleLineIcon } from '../../components/Icons';
import Analytics from "../../services/Analytics";
import ModalBulkVoucherUpload from './Modals/ModalBulkVoucherUpload';
import ModalBulkVoucherManage from './Modals/ModalBulkVoucherManage';
import ModalBulkVoucherEdit from './Modals/ModalBulkVoucherEdit';
import { rowsToCsv, downloadCsv, fetchAllPages, ExportLimitError, EXPORT_MAX_ROWS } from '../../utils/exportCsv';
import { goClient, countRows, requestEmailExport, exportStatus, isRequestError } from '../../utils/exportClient';
import { loadGroupOptions } from '../../utils/exportOptions';
import ExportModal from '../../components/Export/ExportModal';
import VoucherExportFilters, { VOUCHER_EXPORT_DEFAULTS, toVoucherParams, toVoucherEmailParams, hasEmailOnlyFilters } from './Modals/VoucherExportFilters';
import { VOUCHER_ROUTE_API } from '../../constants';

const DropdownToggle = styled(DropdownToggleBs)`
  border: none;
  padding: 0px;
  &:active,&:focus,&:hover{
    border: none;
    padding: 0px;
    background: transparent;
    outline: none;
    box-shadow: none;
  }
  ~ .dropdown-menu{
    background-color: rgba(255,255,255,.8);
  }
`
const DropdownItem = styled(DropdownItemBs)`
  text-transform: capitalize;
`

const defaultParams = {
  sort_by : DEFAULT_SORT_BY,
  per_page : DEFAULT_PER_PAGE
}

// Mirrors the Go export catalogue (internal/modules/exportreport/service/voucher_source.go).
export const VOUCHER_EXPORT_COLUMNS = [
  { name: 'id' }, { name: 'code' }, { name: 'name' }, { name: 'group_name' }, { name: 'description' },
  { name: 'voucher_type' }, { name: 'deduct_type' }, { name: 'type' }, { name: 'amount' }, { name: 'max_amount' },
  { name: 'minimum_purchase' }, { name: 'currency' }, { name: 'active' }, { name: 'franchise' },
  { name: 'platform_specifications' }, { name: 'domain' }, { name: 'is_cashback' }, { name: 'disposable_voucher' },
  { name: 'auto_apply' }, { name: 'new_user_only' }, { name: 'limit' }, { name: 'limit_per_user' }, { name: 'daily_limit' },
  { name: 'daily_start_time' }, { name: 'card_limit' }, { name: 'listing_standard' }, { name: 'listing_pre_order' },
  { name: 'listing_pre_verified' }, { name: 'started_at' }, { name: 'ended_at' }, { name: 'new_user_started_at' },
  { name: 'new_user_ended_at' }, { name: 'created_at' }, { name: 'updated_at' },
  { name: 'sku_count', emailOnly: true }, { name: 'skus', emailOnly: true }
];

const BOOL_COLUMNS = ['active', 'is_cashback', 'disposable_voucher', 'auto_apply', 'new_user_only', 'listing_standard', 'listing_pre_order', 'listing_pre_verified'];

const voucherRow = item => {
  const row = {};
  VOUCHER_EXPORT_COLUMNS.forEach(c => {
    if (c.emailOnly) return;
    const v = item[c.name];
    row[c.name] = BOOL_COLUMNS.includes(c.name) ? (v ? 1 : 0) : (v === undefined || v === null ? '' : v);
  });
  return row;
};

const pickColumns = (row, columns) => {
  const out = {};
  columns.forEach(c => { out[c] = row[c]; });
  return out;
};
const options = [{
  label: 'Voucher for App',
  value: 'APP'
}, {
  label: 'Voucher for Web',
  value: 'WEB'
}];

const RowHeader = (props) => {
  const isActive = (value) => props.platformSpecification?(props.platformSpecification === value): (value === '')
  return (
    <tr>
      <Th>No.</Th>
      <Th>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
          <p style={{marginRight: 10, marginBottom: 0}}>
            Code
            {
              props.platformSpecification?
              <span className="text-capitalize ml-1" style={{fontSize: '.5rem'}}>({props.platformSpecification})</span>
              : null
            }
          </p>
          <ButtonDropdown isOpen={props.dropdownOpen} toggle={props.onDropdownOpenChange}>
            <DropdownToggle size="sm">
              <SimpleLineIcon iconType="options-vertical"/>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem header>Show Only: </DropdownItem>
              <DropdownItem
                onClick={() => props.onPlatformSpecificationChanged('')}
                active={isActive('')}
              >
                { isActive('')? <SimpleLineIcon iconType="check"/>: null }All
              </DropdownItem>
              {
                options.map((item, idx) => (
                  <DropdownItem
                    onClick={() => props.onPlatformSpecificationChanged(item.value)}
                    active={isActive(item.value)}
                    key={idx}
                  >
                    { isActive(item.value)? <SimpleLineIcon iconType="check"/>: null }{item.label}
                  </DropdownItem>
                ))
              }
            </DropdownMenu>
          </ButtonDropdown>
        </div>
      </Th>
      <Th>Active</Th>
      <Th>Max. Amount</Th>
      <Th>Duration</Th>
      <Th>Updated</Th>
      <Th>Action</Th>
    </tr>
  )
}

class VoucherIndex extends Component{
  constructor(props){
    super(props);
    this.state={
      _params:{
        ...defaultParams
      },
      _filterOpen:false,
      _bulkOpen:false,
      _manageOpen:false,
      _editOpen:false,
      _exporting:false,
      _exportModalOpen:false,
      _exportProgress:0,
      _exportRowCount:0,
      _emailStatus:null
    }
    this._handleBulkUpload=()=>this.setState({_bulkOpen:true});
    this._handleCloseBulk=()=>this.setState({_bulkOpen:false});
    this._handleBulkManage=()=>this.setState({_manageOpen:true});
    this._handleCloseManage=()=>this.setState({_manageOpen:false});
    this._handleBulkEdit=()=>this.setState({_editOpen:true});
    this._handleCloseEdit=()=>this.setState({_editOpen:false});
    this._handleExport=this._handleExport.bind(this);
    this._handleExportEmail=this._handleExportEmail.bind(this);
    this._countExportRows=this._countExportRows.bind(this);
    this._toggleExportModal=this._toggleExportModal.bind(this);
    this._handleGoto=this._handleGoto.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleParamsChange = this._handleParamsChange.bind(this);
    this._handleParamsChangeAndSubmit = this._handleParamsChangeAndSubmit.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
  }

  componentWillMount(){
    const { email } = this.props.injectedProps;
    this._getList(this.state._params);
    Analytics.recordPageView('voucher_list', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  _onRenderRowItem(){
    if(this.props.voucher.list.status_code===200 && this.props.voucher.list.data.length>0)
    {
      const { current_page,per_page } =  this.props.voucher.list;
      return this.props.voucher.list.data.map((item,index)=>
        (
          <tr key={generateNumber(per_page,current_page,index)}>
            <th className="v-center" scope="row">{ generateNumber(per_page,current_page,index) }</th>
            <td className="v-center">
              <div>
                { item.code }
              </div>
              <small>Minimum Purchase <TextRupiah prefix="Rp. " value={item.minimum_purchase}/></small>
            </td>
            <td className="v-center"><CheckReadOnly check={item.active}/></td>
            <td className="v-center">
              {item.max_amount && (
                <TextRupiah prefix="Rp. " value={item.max_amount}/>
              )}
            </td>
            <td className="v-center">
              {
                item.started_at === null && item.ended_at === null ?(
                  <div style={{fontStyle: 'italic'}}>Not set yet.</div>
                ):(
                  <div>
                    <div>Start: <span>{ item.started_at||'(Not Set)' }</span></div>
                    <div>End: <span>{ item.ended_at||'(Not Set)' }</span></div>
                  </div>
                )
              }
            </td>
            <td className="v-center">{ <DateToHuman value={item.updated_at} id={`tooltip_${generateNumber(per_page,current_page,index)}`}/> }</td>
            <td className="v-center">
                <Link to={`/vouchers/${item.id}`} className="btn btn-link">Details</Link>
            </td>
          </tr>
        )
      )
    }
    return null;
  }

  _onRenderPagination(){
    const { status_code,data } = this.props.voucher.list;
    const hasData = (status_code===200 && data.length) || null;
    return hasData && (
      <Paginations
        size="sm"
        lastPage={this.props.voucher.list.last_page}
        perPage={this.props.voucher.list.per_page}
        total={this.props.voucher.list.total}
        maxPage={8}
        path={this.props.voucher.list.path}
        currentPage={this.props.voucher.list.current_page}
        prevPageUrl={this.props.voucher.list.prev_page_url}
        nextPageUrl={this.props.voucher.list.next_page_url}
        handleGotoCallback={this._handleGoto}
      />
    )
  }

  /**
   * Handle callback when user click pagination items
   * @author pewe
   * @param {integer} page
   */
  _handleGoto(page){
    const _params=this.state._params;
    _params.page=page;
    this.setState({_params},()=>this._getList(this.state._params));
  }

  _toggleFilterPanel(){
    this.setState({_filterOpen:!this.state._filterOpen})
  }

  _handleToggleFilterPanel(e){
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }

  _getList(rawParams = {} ){
    let params = {};
    Object.keys(rawParams)
    .filter(key => rawParams[key]!='')
    .forEach(key=> params[key] = rawParams[key]);
    this.props.getList({params});
  }

  _refreshList(){
    const {page, ..._params} = this.state._params;
    this.setState({
      _params
    },()=>this._getList(this.state._params));
  }

  _handleParamsChange(e){
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    this.setState({_params});
  }

  _handleParamsChangeAndSubmit(e){
    // Exclude page...
    const { page , ..._params } = this.state._params;
    _params[e.target.name] = e.target.value;
    this.setState({_params},()=>{
      this._getList(this.state._params);
    });
  }

  _handleResetFilter(e){
    e.preventDefault();
    const newState = this.state._filterOpen?{_filterOpen:!this.state._filterOpen}:{};
    this.setState({
      ...newState,
      _params:{
        ...defaultParams
      }
    },()=>this._getList(this.state._params));
  }

  componentWillUnmount(){
    this._unmounted = true;
  }

  _setStateIfMounted(patch){
    if (!this._unmounted) this.setState(patch);
  }

  _toggleExportModal(){
    if(this.state._exporting) return;
    this.setState({ _exportModalOpen: !this.state._exportModalOpen });
  }

  _exportParams(filters){
    const { page, per_page, ..._rest } = this.state._params;
    const panel = {};
    Object.keys(_rest)
      .filter(key => _rest[key] !== '' && _rest[key] != null)
      .forEach(key => { panel[key] = _rest[key]; });
    return toVoucherParams(panel, filters);
  }

  _countExportRows(filters){
    return countRows(goClient(), VOUCHER_ROUTE_API, this._exportParams(filters));
  }

  async _handleExport(filters, columns){
    if(this.state._exporting) return;
    this._setStateIfMounted({ _exporting: true, _exportProgress: 0, _exportRowCount: 0, _emailStatus: null });
    try {
      const rows = await fetchAllPages(goClient(), VOUCHER_ROUTE_API, this._exportParams(filters), {
        onProgress: (progress, count) => this._setStateIfMounted({ _exportProgress: progress, _exportRowCount: count })
      });
      if (this._unmounted) return;
      if (!rows.length) {
        this._setStateIfMounted({ _exporting: false, _exportProgress: 0, _exportRowCount: 0 });
        window.alert('No vouchers match the selected options.');
        return;
      }
      const stamp = new Date().toISOString().slice(0, 10);
      downloadCsv(rowsToCsv(rows.map(item => pickColumns(voucherRow(item), columns))), `vouchers_${stamp}.csv`);
      this._setStateIfMounted({ _exporting: false, _exportProgress: 100, _exportModalOpen: false });
    } catch (err) {
      this._setStateIfMounted({ _exporting: false, _exportProgress: 0, _exportRowCount: 0 });
      if (this._unmounted) return;
      if (err instanceof ExportLimitError) { window.alert(err.message); return; }
      if (isRequestError(err)) { window.alert('Export failed. Please try again.'); return; }
      throw err;
    }
  }

  async _handleExportEmail(filters, columns){
    if(this.state._exporting) return;
    this._setStateIfMounted({ _exporting: true, _emailStatus: null });
    try {
      const client = goClient();
      const filtersForServer = {};
      Object.entries({ ...this._exportParams(filters), ...toVoucherEmailParams(filters) }).forEach(([k, v]) => { filtersForServer[k] = String(v); });
      let status = await requestEmailExport(client, 'vouchers', filtersForServer, columns);
      if (this._unmounted) return;
      this._setStateIfMounted({ _emailStatus: status });
      while (status && (status.state === 'queued' || status.state === 'waiting' || status.state === 'running')) {
        await new Promise(resolve => setTimeout(resolve, 5000));
        if (this._unmounted) return;
        status = await exportStatus(client, status.id);
        if (this._unmounted) return;
        this._setStateIfMounted({ _emailStatus: status });
      }
      this._setStateIfMounted({ _exporting: false });
    } catch (err) {
      const data = err && err.response && err.response.data;
      const message = data && data.errors && data.errors.columns ? data.errors.columns.join(' ') : (data && data.message) || 'Email export failed. Please try again.';
      this._setStateIfMounted({ _exporting: false, _emailStatus: { state: 'failed', message } });
    }
  }

  render(){
    return(
      <div className="animated fadeIn">
        <ExportModal
          isOpen={this.state._exportModalOpen}
          toggle={this._toggleExportModal}
          title="Export Vouchers"
          screen="vouchers"
          columns={VOUCHER_EXPORT_COLUMNS}
          isAdmin
          defaultFilters={VOUCHER_EXPORT_DEFAULTS}
          renderFilters={(filters, setFilter, disabled) => (
            <VoucherExportFilters filters={filters} setFilter={setFilter} disabled={disabled} loadGroups={loadGroupOptions} />
          )}
          countRows={this._countExportRows}
          countCaveat={filters => (hasEmailOnlyFilters(filters) ? 'before the SKU filter, which only the email job applies' : '')}
          onDownload={this._handleExport}
          onEmail={this._handleExportEmail}
          isExporting={this.state._exporting}
          progress={this.state._exportProgress}
          rowCount={this.state._exportRowCount}
          maxRows={EXPORT_MAX_ROWS}
          emailStatus={this.state._emailStatus}
          userEmail={this.props.injectedProps && this.props.injectedProps.email}
        />
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Voucher List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                  onBulkUpload={this._handleBulkUpload}
                  onBulkManage={this._handleBulkManage}
                  onBulkEdit={this._handleBulkEdit}
                  onExport={this._toggleExportModal}
                  exporting={this.state._exporting}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FilterPanel
                  {...this.state._params}
                  onHandleChange={this._handleParamsChange}
                  onHandleSearch={this._handleRefresh}
                  onHandleChangeAndSubmit={this._handleParamsChangeAndSubmit}
                  isOpen={this.state._filterOpen}
                />
              </FilterContainer>
              <CardBody>
                <CardText>
                  In this section will display our vouchers.
                </CardText>
                <div className="table-responsive" ref={tableRef => this.tableRef = tableRef}>
                  <PaginationSummaries
                    from={this.props.voucher.list.from}
                    to={this.props.voucher.list.to}
                    total={this.props.voucher.list.total}
                  />
                  <Tbl>
                    <TblHead>
                      <RowHeader
                        dropdownOpen={this.state._dropdownOpen}
                        onDropdownOpenChange={()=>this.setState({_dropdownOpen: !this.state._dropdownOpen})}
                        platformSpecification={this.state._params.platform_specifications}
                        onPlatformSpecificationChanged={async (value) => {
                          await this.setState({
                            _params: {
                              ...this.state._params,
                              platform_specifications: value === ''? null: value,
                              page: 1
                            }
                          });
                          this._getList(this.state._params);
                        }}
                      />
                    </TblHead>
                    <TblBody
                      isLoad={this.props.voucher.isFetch}
                      hasRow={this.props.voucher.list.status_code===200&&this.props.voucher.list.data.length>0}
                      columnCount={7}
                    >
                      { this._onRenderRowItem() }
                    </TblBody>
                  </Tbl>
                </div>
                { this._onRenderPagination() }
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ModalBulkVoucherUpload
          isOpen={this.state._bulkOpen}
          onClose={this._handleCloseBulk}
          onCompleted={this._handleRefresh}
        />
        <ModalBulkVoucherManage
          isOpen={this.state._manageOpen}
          onClose={this._handleCloseManage}
          onCompleted={this._handleRefresh}
        />
        <ModalBulkVoucherEdit
          isOpen={this.state._editOpen}
          onClose={this._handleCloseEdit}
          onCompleted={this._handleRefresh}
        />
      </div>
    )
  }
}
const mapStateToProps=({voucher, auth: { isFetch, roles, isLogged, id, email }})=>{
	return {
    voucher,
    guardData: { isFetch, roles, isLogged, id, email }
	}
}
const mapDispatchToProps=(dispatch)=>
{
	return {
		getList:(filter)=>dispatch(getListVoucher(filter)),
	}
}
const enhance = connect(mapStateToProps,mapDispatchToProps);
export default enhance(privateView(VoucherIndex))